// extracted by mini-css-extract-plugin
module.exports = {"className":"hy-AM_className__23eQf"};